// extracted by mini-css-extract-plugin
module.exports = {"defaultImage":"ZR6zqv"};